var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotFound(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 57,
    viewBox: "0 0 68 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.8919 6.36914H8.04577C5.97082 6.36914 4.28906 8.05089 4.28906 10.1258V17.6393H61.8919V6.36914Z",
    fill: "#E2D5FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.8928 4.25671C61.8928 2.18175 60.2111 0.5 58.1361 0.5C52.8404 0.5 43.2934 0.5 38.5023 0.5C36.7053 0.5 35.0449 1.46297 34.1533 3.02326C32.6744 5.61288 30.5869 9.26565 30.5869 9.26565H61.8928V4.25671Z",
    fill: "#E2D5FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.28906 9.88965H61.8919V12.2226H4.28906V9.88965Z",
    fill: "#AA7CFB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.1099 17.1188C66.309 15.6838 65.877 14.2324 64.9265 13.1405C63.9748 12.0473 62.5974 11.4199 61.1485 11.4199C48.3807 11.4199 17.8011 11.4199 5.03334 11.4199C3.5845 11.4199 2.20704 12.0473 1.25534 13.1405C0.304892 14.2324 -0.12713 15.6838 0.0719758 17.1188C1.34174 26.2602 3.80614 44.0019 4.94192 52.1815C5.28629 54.6571 7.40257 56.5004 9.90328 56.5004H56.2786C58.7793 56.5004 60.8956 54.6571 61.24 52.1815C62.3757 44.0019 64.8401 26.2602 66.1099 17.1188Z",
    fill: "#E2D5FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.492727 20.1493C0.586645 19.1061 1.00489 18.1094 1.70489 17.3054C2.65534 16.2135 4.0328 15.5861 5.48164 15.5861H60.7002C62.1491 15.5861 63.5265 16.2135 64.477 17.3054C65.177 18.1094 65.5952 19.1061 65.6892 20.1493L66.1099 17.1188C66.309 15.6838 65.877 14.2324 64.9265 13.1405C63.9748 12.0473 62.5974 11.4199 61.1485 11.4199C48.3807 11.4199 17.8011 11.4199 5.03334 11.4199C3.5845 11.4199 2.20704 12.0473 1.25534 13.1405C0.304892 14.2324 -0.12713 15.6838 0.0719758 17.1188L0.492727 20.1493Z",
    fill: "#EFE9FE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.4575 44.0103C27.4575 42.6279 26.3367 41.5059 24.953 41.5059C22.1743 41.5059 17.7151 41.5059 14.9351 41.5059C13.5527 41.5059 12.4307 42.6279 12.4307 44.0103V46.5148C12.4307 47.8985 13.5527 49.0193 14.9351 49.0193H24.953C26.3367 49.0193 27.4575 47.8985 27.4575 46.5148C27.4575 45.7096 27.4575 44.8168 27.4575 44.0103Z",
    fill: "#9B5AF8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.2393 20.4854C38.9826 20.4854 33.0908 26.3771 33.0908 33.6338C33.0908 40.8905 38.9826 46.7823 46.2393 46.7823C53.496 46.7823 59.3878 40.8905 59.3878 33.6338C59.3878 26.3771 53.496 20.4854 46.2393 20.4854ZM46.2393 24.2421C51.4223 24.2421 55.6311 28.4508 55.6311 33.6338C55.6311 38.8168 51.4223 43.0256 46.2393 43.0256C41.0563 43.0256 36.8475 38.8168 36.8475 33.6338C36.8475 28.4508 41.0563 24.2421 46.2393 24.2421Z",
    fill: "#9B5AF8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.0875 42.7142L64.7684 54.3951C65.5022 55.1289 66.6918 55.1289 67.4256 54.3951C68.1582 53.6625 68.1582 52.4716 67.4256 51.7391L55.7447 40.0582C55.0109 39.3256 53.8213 39.3256 53.0875 40.0582C52.3549 40.7908 52.3549 41.9816 53.0875 42.7142Z",
    fill: "#9B5AF8"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotFound);
export default __webpack_public_path__ + "static/media/notFound.065e041bd420018dfe01a34abade6f5b.svg";
export { ForwardRef as ReactComponent };